var nr = Object.defineProperty;
var _e = (t) => {
  throw TypeError(t);
};
var ar = (t, e, r) => e in t ? nr(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var A = (t, e, r) => ar(t, typeof e != "symbol" ? e + "" : e, r), De = (t, e, r) => e.has(t) || _e("Cannot " + r);
var d = (t, e, r) => (De(t, e, "read from private field"), r ? r.call(t) : e.get(t)), k = (t, e, r) => e.has(t) ? _e("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, r), M = (t, e, r, n) => (De(t, e, "write to private field"), n ? n.call(t, r) : e.set(t, r), r);
var ce = (t, e, r, n) => ({
  set _(a) {
    M(t, e, a, r);
  },
  get _() {
    return d(t, e, n);
  }
});
import { B as ot, a as it, H as Ee, R as or } from "./RouteGuard-BZ_VsiXc.js";
import { z as ct, J as ir } from "./index-DwT-v3zK.js";
import { R as cr, S as lr, u as pe, f as ge, g as ur, L as Te, O as lt } from "./chunk-KNED5TY2-BUPjb3LQ.js";
import { S as ut, v as dt, Q as dr, n as R, w as qe, x as $e, y as B, z as fr, A as hr, B as mr, C as pr, D as Ie, E as Fe, F as gr, h as Qe, G as ze, H as xr, g as ft, I as ht, m as vr, e as F, l as ae, J as mt, K as yr, f as ee, u as br, j as jr, d as wr, Z as Pr, L as Sr, M as Cr } from "./hook-pPrHCB6G.js";
import { E as pt, S as _, a as Nr, R as Er } from "./SlotletProvider-p4XaFFOh.js";
import { j as s } from "./jsx-runtime-C5mzlN2N.js";
import { Button as gt } from "./ui/Button.js";
import { Callout as Tr } from "./ui/Callout.js";
import { M as Mr } from "./mutation-Csa9eQDM.js";
import * as K from "react";
import he, { createContext as Me, StrictMode as xt, useRef as G, useEffect as Q, useState as J, useCallback as W, Suspense as Oe, memo as vt, Component as Or, createElement as Le, useMemo as be, useContext as Ar } from "react";
import * as kr from "react-dom";
import { CircleFadingArrowUpIcon as Rr, LoaderCircleIcon as _r, ExternalLink as Dr, CircleXIcon as qr, ChevronRightIcon as $r, SearchIcon as Ir, SunIcon as Fr, MoonIcon as Qr, MenuIcon as zr, PanelLeftIcon as Lr } from "lucide-react";
import { C as xe } from "./ClientOnly-E7hGysn1.js";
import { c as O } from "./cn-qaFjX9_3.js";
import { A as Br, s as Hr, a as Be, b as Kr, H as Ur, P as Yr, c as Zr, V as Vr, M as Wr } from "./Markdown-DqDbGCj2.js";
import { S as yt } from "./Spinner-mNLZ6awP.js";
import { C as Gr } from "./CategoryHeading-D06WK_Wo.js";
import { isSearchPlugin as Xr, isProfileMenuPlugin as Jr, isNavigationPlugin as es, isEventConsumerPlugin as ts, needsInitialization as rs, isApiIdentityPlugin as ss, isMdxProviderPlugin as ns, hasHead as as } from "./zudoku.plugins.js";
import { o as os } from "./objectEntries-yMIkr2mI.js";
import { B as Se } from "./Button-BBNrKpQd.js";
import { DropdownMenu as is, DropdownMenuTrigger as cs, DropdownMenuContent as ls, DropdownMenuLabel as us, DropdownMenuSeparator as je, DropdownMenuSub as ds, DropdownMenuSubTrigger as fs, DropdownMenuPortal as hs, DropdownMenuSubContent as ms, DropdownMenuItem as ps } from "./ui/DropdownMenu.js";
import { VisuallyHidden as bt } from "@radix-ui/react-visually-hidden";
import { D as gs, a as xs, b as jt, c as wt, d as z } from "./Drawer-CEwbkLDb.js";
import { a as vs } from "./index-CPNSgwSb.js";
const Ce = {}, Pt = he.createContext(Ce);
function St(t) {
  const e = he.useContext(Pt);
  return he.useMemo(
    function() {
      return typeof t == "function" ? t(e) : { ...e, ...t };
    },
    [e, t]
  );
}
function ys(t) {
  let e;
  return t.disableParentContext ? e = typeof t.components == "function" ? t.components(Ce) : t.components || Ce : e = St(t.components), he.createElement(
    Pt.Provider,
    { value: e },
    t.children
  );
}
var I, st, bs = (st = class extends ut {
  constructor(e = {}) {
    super();
    k(this, I);
    this.config = e, M(this, I, /* @__PURE__ */ new Map());
  }
  build(e, r, n) {
    const a = r.queryKey, i = r.queryHash ?? dt(a, r);
    let o = this.get(i);
    return o || (o = new dr({
      client: e,
      queryKey: a,
      queryHash: i,
      options: e.defaultQueryOptions(r),
      state: n,
      defaultOptions: e.getQueryDefaults(a)
    }), this.add(o)), o;
  }
  add(e) {
    d(this, I).has(e.queryHash) || (d(this, I).set(e.queryHash, e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const r = d(this, I).get(e.queryHash);
    r && (e.destroy(), r === e && d(this, I).delete(e.queryHash), this.notify({ type: "removed", query: e }));
  }
  clear() {
    R.batch(() => {
      this.getAll().forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return d(this, I).get(e);
  }
  getAll() {
    return [...d(this, I).values()];
  }
  find(e) {
    const r = { exact: !0, ...e };
    return this.getAll().find(
      (n) => qe(r, n)
    );
  }
  findAll(e = {}) {
    const r = this.getAll();
    return Object.keys(e).length > 0 ? r.filter((n) => qe(e, n)) : r;
  }
  notify(e) {
    R.batch(() => {
      this.listeners.forEach((r) => {
        r(e);
      });
    });
  }
  onFocus() {
    R.batch(() => {
      this.getAll().forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    R.batch(() => {
      this.getAll().forEach((e) => {
        e.onOnline();
      });
    });
  }
}, I = new WeakMap(), st), H, $, oe, nt, js = (nt = class extends ut {
  constructor(e = {}) {
    super();
    k(this, H);
    k(this, $);
    k(this, oe);
    this.config = e, M(this, H, /* @__PURE__ */ new Set()), M(this, $, /* @__PURE__ */ new Map()), M(this, oe, 0);
  }
  build(e, r, n) {
    const a = new Mr({
      mutationCache: this,
      mutationId: ++ce(this, oe)._,
      options: e.defaultMutationOptions(r),
      state: n
    });
    return this.add(a), a;
  }
  add(e) {
    d(this, H).add(e);
    const r = le(e);
    if (typeof r == "string") {
      const n = d(this, $).get(r);
      n ? n.push(e) : d(this, $).set(r, [e]);
    }
    this.notify({ type: "added", mutation: e });
  }
  remove(e) {
    if (d(this, H).delete(e)) {
      const r = le(e);
      if (typeof r == "string") {
        const n = d(this, $).get(r);
        if (n)
          if (n.length > 1) {
            const a = n.indexOf(e);
            a !== -1 && n.splice(a, 1);
          } else n[0] === e && d(this, $).delete(r);
      }
    }
    this.notify({ type: "removed", mutation: e });
  }
  canRun(e) {
    const r = le(e);
    if (typeof r == "string") {
      const n = d(this, $).get(r), a = n == null ? void 0 : n.find(
        (i) => i.state.status === "pending"
      );
      return !a || a === e;
    } else
      return !0;
  }
  runNext(e) {
    var n;
    const r = le(e);
    if (typeof r == "string") {
      const a = (n = d(this, $).get(r)) == null ? void 0 : n.find((i) => i !== e && i.state.isPaused);
      return (a == null ? void 0 : a.continue()) ?? Promise.resolve();
    } else
      return Promise.resolve();
  }
  clear() {
    R.batch(() => {
      d(this, H).forEach((e) => {
        this.notify({ type: "removed", mutation: e });
      }), d(this, H).clear(), d(this, $).clear();
    });
  }
  getAll() {
    return Array.from(d(this, H));
  }
  find(e) {
    const r = { exact: !0, ...e };
    return this.getAll().find(
      (n) => $e(r, n)
    );
  }
  findAll(e = {}) {
    return this.getAll().filter((r) => $e(e, r));
  }
  notify(e) {
    R.batch(() => {
      this.listeners.forEach((r) => {
        r(e);
      });
    });
  }
  resumePausedMutations() {
    const e = this.getAll().filter((r) => r.state.isPaused);
    return R.batch(
      () => Promise.all(
        e.map((r) => r.continue().catch(B))
      )
    );
  }
}, H = new WeakMap(), $ = new WeakMap(), oe = new WeakMap(), nt);
function le(t) {
  var e;
  return (e = t.options.scope) == null ? void 0 : e.id;
}
function He(t) {
  return {
    onFetch: (e, r) => {
      var b, v, g, y, m;
      const n = e.options, a = (g = (v = (b = e.fetchOptions) == null ? void 0 : b.meta) == null ? void 0 : v.fetchMore) == null ? void 0 : g.direction, i = ((y = e.state.data) == null ? void 0 : y.pages) || [], o = ((m = e.state.data) == null ? void 0 : m.pageParams) || [];
      let f = { pages: [], pageParams: [] }, h = 0;
      const l = async () => {
        let p = !1;
        const C = (x) => {
          Object.defineProperty(x, "signal", {
            enumerable: !0,
            get: () => (e.signal.aborted ? p = !0 : e.signal.addEventListener("abort", () => {
              p = !0;
            }), e.signal)
          });
        }, E = fr(e.options, e.fetchOptions), T = async (x, j, c) => {
          if (p)
            return Promise.reject();
          if (j == null && x.pages.length)
            return Promise.resolve(x);
          const S = {
            client: e.client,
            queryKey: e.queryKey,
            pageParam: j,
            direction: c ? "backward" : "forward",
            meta: e.options.meta
          };
          C(S);
          const D = await E(
            S
          ), { maxPages: q } = e.options, L = c ? hr : mr;
          return {
            pages: L(x.pages, D, q),
            pageParams: L(x.pageParams, j, q)
          };
        };
        if (a && i.length) {
          const x = a === "backward", j = x ? ws : Ke, c = {
            pages: i,
            pageParams: o
          }, S = j(n, c);
          f = await T(c, S, x);
        } else {
          const x = t ?? i.length;
          do {
            const j = h === 0 ? o[0] ?? n.initialPageParam : Ke(n, f);
            if (h > 0 && j == null)
              break;
            f = await T(f, j), h++;
          } while (h < x);
        }
        return f;
      };
      e.options.persister ? e.fetchFn = () => {
        var p, C;
        return (C = (p = e.options).persister) == null ? void 0 : C.call(
          p,
          l,
          {
            client: e.client,
            queryKey: e.queryKey,
            meta: e.options.meta,
            signal: e.signal
          },
          r
        );
      } : e.fetchFn = l;
    }
  };
}
function Ke(t, { pages: e, pageParams: r }) {
  const n = e.length - 1;
  return e.length > 0 ? t.getNextPageParam(
    e[n],
    e,
    r[n],
    r
  ) : void 0;
}
function ws(t, { pages: e, pageParams: r }) {
  var n;
  return e.length > 0 ? (n = t.getPreviousPageParam) == null ? void 0 : n.call(t, e[0], e, r[0], r) : void 0;
}
var N, Y, Z, te, re, V, se, ne, at, Ps = (at = class {
  constructor(t = {}) {
    k(this, N);
    k(this, Y);
    k(this, Z);
    k(this, te);
    k(this, re);
    k(this, V);
    k(this, se);
    k(this, ne);
    M(this, N, t.queryCache || new bs()), M(this, Y, t.mutationCache || new js()), M(this, Z, t.defaultOptions || {}), M(this, te, /* @__PURE__ */ new Map()), M(this, re, /* @__PURE__ */ new Map()), M(this, V, 0);
  }
  mount() {
    ce(this, V)._++, d(this, V) === 1 && (M(this, se, pr.subscribe(async (t) => {
      t && (await this.resumePausedMutations(), d(this, N).onFocus());
    })), M(this, ne, Ie.subscribe(async (t) => {
      t && (await this.resumePausedMutations(), d(this, N).onOnline());
    })));
  }
  unmount() {
    var t, e;
    ce(this, V)._--, d(this, V) === 0 && ((t = d(this, se)) == null || t.call(this), M(this, se, void 0), (e = d(this, ne)) == null || e.call(this), M(this, ne, void 0));
  }
  isFetching(t) {
    return d(this, N).findAll({ ...t, fetchStatus: "fetching" }).length;
  }
  isMutating(t) {
    return d(this, Y).findAll({ ...t, status: "pending" }).length;
  }
  /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */
  getQueryData(t) {
    var r;
    const e = this.defaultQueryOptions({ queryKey: t });
    return (r = d(this, N).get(e.queryHash)) == null ? void 0 : r.state.data;
  }
  ensureQueryData(t) {
    const e = this.defaultQueryOptions(t), r = d(this, N).build(this, e), n = r.state.data;
    return n === void 0 ? this.fetchQuery(t) : (t.revalidateIfStale && r.isStaleByTime(Fe(e.staleTime, r)) && this.prefetchQuery(e), Promise.resolve(n));
  }
  getQueriesData(t) {
    return d(this, N).findAll(t).map(({ queryKey: e, state: r }) => {
      const n = r.data;
      return [e, n];
    });
  }
  setQueryData(t, e, r) {
    const n = this.defaultQueryOptions({ queryKey: t }), a = d(this, N).get(
      n.queryHash
    ), i = a == null ? void 0 : a.state.data, o = gr(e, i);
    if (o !== void 0)
      return d(this, N).build(this, n).setData(o, { ...r, manual: !0 });
  }
  setQueriesData(t, e, r) {
    return R.batch(
      () => d(this, N).findAll(t).map(({ queryKey: n }) => [
        n,
        this.setQueryData(n, e, r)
      ])
    );
  }
  getQueryState(t) {
    var r;
    const e = this.defaultQueryOptions({ queryKey: t });
    return (r = d(this, N).get(
      e.queryHash
    )) == null ? void 0 : r.state;
  }
  removeQueries(t) {
    const e = d(this, N);
    R.batch(() => {
      e.findAll(t).forEach((r) => {
        e.remove(r);
      });
    });
  }
  resetQueries(t, e) {
    const r = d(this, N);
    return R.batch(() => (r.findAll(t).forEach((n) => {
      n.reset();
    }), this.refetchQueries(
      {
        type: "active",
        ...t
      },
      e
    )));
  }
  cancelQueries(t, e = {}) {
    const r = { revert: !0, ...e }, n = R.batch(
      () => d(this, N).findAll(t).map((a) => a.cancel(r))
    );
    return Promise.all(n).then(B).catch(B);
  }
  invalidateQueries(t, e = {}) {
    return R.batch(() => (d(this, N).findAll(t).forEach((r) => {
      r.invalidate();
    }), (t == null ? void 0 : t.refetchType) === "none" ? Promise.resolve() : this.refetchQueries(
      {
        ...t,
        type: (t == null ? void 0 : t.refetchType) ?? (t == null ? void 0 : t.type) ?? "active"
      },
      e
    )));
  }
  refetchQueries(t, e = {}) {
    const r = {
      ...e,
      cancelRefetch: e.cancelRefetch ?? !0
    }, n = R.batch(
      () => d(this, N).findAll(t).filter((a) => !a.isDisabled()).map((a) => {
        let i = a.fetch(void 0, r);
        return r.throwOnError || (i = i.catch(B)), a.state.fetchStatus === "paused" ? Promise.resolve() : i;
      })
    );
    return Promise.all(n).then(B);
  }
  fetchQuery(t) {
    const e = this.defaultQueryOptions(t);
    e.retry === void 0 && (e.retry = !1);
    const r = d(this, N).build(this, e);
    return r.isStaleByTime(
      Fe(e.staleTime, r)
    ) ? r.fetch(e) : Promise.resolve(r.state.data);
  }
  prefetchQuery(t) {
    return this.fetchQuery(t).then(B).catch(B);
  }
  fetchInfiniteQuery(t) {
    return t.behavior = He(t.pages), this.fetchQuery(t);
  }
  prefetchInfiniteQuery(t) {
    return this.fetchInfiniteQuery(t).then(B).catch(B);
  }
  ensureInfiniteQueryData(t) {
    return t.behavior = He(t.pages), this.ensureQueryData(t);
  }
  resumePausedMutations() {
    return Ie.isOnline() ? d(this, Y).resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return d(this, N);
  }
  getMutationCache() {
    return d(this, Y);
  }
  getDefaultOptions() {
    return d(this, Z);
  }
  setDefaultOptions(t) {
    M(this, Z, t);
  }
  setQueryDefaults(t, e) {
    d(this, te).set(Qe(t), {
      queryKey: t,
      defaultOptions: e
    });
  }
  getQueryDefaults(t) {
    const e = [...d(this, te).values()], r = {};
    return e.forEach((n) => {
      ze(t, n.queryKey) && Object.assign(r, n.defaultOptions);
    }), r;
  }
  setMutationDefaults(t, e) {
    d(this, re).set(Qe(t), {
      mutationKey: t,
      defaultOptions: e
    });
  }
  getMutationDefaults(t) {
    const e = [...d(this, re).values()], r = {};
    return e.forEach((n) => {
      ze(t, n.mutationKey) && Object.assign(r, n.defaultOptions);
    }), r;
  }
  defaultQueryOptions(t) {
    if (t._defaulted)
      return t;
    const e = {
      ...d(this, Z).queries,
      ...this.getQueryDefaults(t.queryKey),
      ...t,
      _defaulted: !0
    };
    return e.queryHash || (e.queryHash = dt(
      e.queryKey,
      e
    )), e.refetchOnReconnect === void 0 && (e.refetchOnReconnect = e.networkMode !== "always"), e.throwOnError === void 0 && (e.throwOnError = !!e.suspense), !e.networkMode && e.persister && (e.networkMode = "offlineFirst"), e.queryFn === xr && (e.enabled = !1), e;
  }
  defaultMutationOptions(t) {
    return t != null && t._defaulted ? t : {
      ...d(this, Z).mutations,
      ...(t == null ? void 0 : t.mutationKey) && this.getMutationDefaults(t.mutationKey),
      ...t,
      _defaulted: !0
    };
  }
  clear() {
    d(this, N).clear(), d(this, Y).clear();
  }
}, N = new WeakMap(), Y = new WeakMap(), Z = new WeakMap(), te = new WeakMap(), re = new WeakMap(), V = new WeakMap(), se = new WeakMap(), ne = new WeakMap(), at);
function Ss(t) {
  return t;
}
function Ue(t, e, r) {
  var h, l;
  if (typeof e != "object" || e === null)
    return;
  const n = t.getMutationCache(), a = t.getQueryCache(), i = ((h = r == null ? void 0 : r.defaultOptions) == null ? void 0 : h.deserializeData) ?? ((l = t.getDefaultOptions().hydrate) == null ? void 0 : l.deserializeData) ?? Ss, o = e.mutations || [], f = e.queries || [];
  o.forEach(({ state: b, ...v }) => {
    var g, y;
    n.build(
      t,
      {
        ...(g = t.getDefaultOptions().hydrate) == null ? void 0 : g.mutations,
        ...(y = r == null ? void 0 : r.defaultOptions) == null ? void 0 : y.mutations,
        ...v
      },
      b
    );
  }), f.forEach(({ queryKey: b, state: v, queryHash: g, meta: y, promise: m }) => {
    var E, T;
    let p = a.get(g);
    const C = v.data === void 0 ? v.data : i(v.data);
    if (p) {
      if (p.state.dataUpdatedAt < v.dataUpdatedAt) {
        const { fetchStatus: x, ...j } = v;
        p.setState({
          ...j,
          data: C
        });
      }
    } else
      p = a.build(
        t,
        {
          ...(E = t.getDefaultOptions().hydrate) == null ? void 0 : E.queries,
          ...(T = r == null ? void 0 : r.defaultOptions) == null ? void 0 : T.queries,
          queryKey: b,
          queryHash: g,
          meta: y
        },
        // Reset fetch status to idle to avoid
        // query being stuck in fetching state upon hydration
        {
          ...v,
          data: C,
          fetchStatus: "idle"
        }
      );
    if (m) {
      const x = Promise.resolve(m).then(i);
      p.fetch(void 0, { initialPromise: x });
    }
  });
}
var Ye = (t, e) => typeof t == "object" && t !== null && e in t, Cs = ({
  children: t,
  options: e = {},
  state: r,
  queryClient: n
}) => {
  const a = ft(n), [i, o] = K.useState(), f = K.useRef(e);
  return f.current = e, K.useMemo(() => {
    if (r) {
      if (typeof r != "object")
        return;
      const h = a.getQueryCache(), l = r.queries || [], b = [], v = [];
      for (const g of l) {
        const y = h.get(g.queryHash);
        if (!y)
          b.push(g);
        else {
          const m = g.state.dataUpdatedAt > y.state.dataUpdatedAt || // RSC special serialized then-able chunks
          Ye(g.promise, "status") && Ye(y.promise, "status") && g.promise.status !== y.promise.status, p = i == null ? void 0 : i.find(
            (C) => C.queryHash === g.queryHash
          );
          m && (!p || g.state.dataUpdatedAt > p.state.dataUpdatedAt) && v.push(g);
        }
      }
      b.length > 0 && Ue(a, { queries: b }, f.current), v.length > 0 && o(
        (g) => g ? [...g, ...v] : v
      );
    }
  }, [a, i, r]), K.useEffect(() => {
    i && (Ue(a, { queries: i }, f.current), o(void 0));
  }, [a, i]), t;
};
function Ns({ error: t }) {
  return /* @__PURE__ */ s.jsx(pt, { error: t });
}
/**
 * react-router v7.5.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Es(t) {
  return /* @__PURE__ */ K.createElement(cr, { flushSync: kr.flushSync, ...t });
}
const Ne = Me({ stagger: !1 }), Ts = new Ps({
  defaultOptions: {
    queries: {
      staleTime: 1e3 * 60 * 5
    }
  }
}), Ms = ({
  router: t,
  hydrate: e = !1
}) => /* @__PURE__ */ s.jsx(xt, { children: /* @__PURE__ */ s.jsx(ht, { client: Ts, children: /* @__PURE__ */ s.jsx(Cs, { state: e ? window.DATA : void 0, children: /* @__PURE__ */ s.jsx(ot, { value: !1, children: /* @__PURE__ */ s.jsx(it, { children: /* @__PURE__ */ s.jsx(Ne.Provider, { value: { stagger: !e }, children: /* @__PURE__ */ s.jsx(Es, { router: t }) }) }) }) }) }) }), Os = ({
  router: t,
  context: e,
  queryClient: r,
  helmetContext: n,
  bypassProtection: a = !1
}) => /* @__PURE__ */ s.jsx(xt, { children: /* @__PURE__ */ s.jsx(ht, { client: r, children: /* @__PURE__ */ s.jsx(it, { context: n, children: /* @__PURE__ */ s.jsx(ot, { value: a, children: /* @__PURE__ */ s.jsx(lr, { router: t, context: e }) }) }) }) }), As = ({
  buildId: t,
  endpoint: e = "/__zuplo/docs"
}) => {
  var a, i;
  const r = vr({
    queryKey: ["zuplo-build-check", t, e],
    refetchInterval: 2e3,
    enabled: !!t,
    queryFn: () => fetch(e).then((o) => o.json())
  });
  if (((a = r.data) == null ? void 0 : a.buildId) === t)
    return null;
  const n = ((i = r.data) == null ? void 0 : i.status) === "completed";
  return /* @__PURE__ */ s.jsxs("div", { className: "fixed flex flex-col gap-3 p-4 rounded-xl w-96 border z-20 bg-background left-0 right-0 top-4 mx-auto shadow-lg", children: [
    n ? /* @__PURE__ */ s.jsxs("div", { className: "flex flex-row items-center gap-2", children: [
      /* @__PURE__ */ s.jsx(Rr, { size: 16 }),
      /* @__PURE__ */ s.jsx("span", { className: "text-sm", children: "New version available" })
    ] }) : /* @__PURE__ */ s.jsxs("div", { className: "flex flex-row items-center gap-2", children: [
      /* @__PURE__ */ s.jsx(_r, { size: 16, className: "animate-spin" }),
      /* @__PURE__ */ s.jsx("span", { className: "text-sm", children: "Building new version..." })
    ] }),
    /* @__PURE__ */ s.jsx("span", { className: "text-xs", children: n ? "To see the new version, reload the page now." : "A new version of the developer portal will be available soon." }),
    /* @__PURE__ */ s.jsx(
      gt,
      {
        variant: "outline",
        size: "sm",
        className: "w-full",
        onClick: () => {
          window.location.reload();
        },
        children: "Reload"
      }
    )
  ] });
}, ks = () => {
  const t = pe(), e = G(t.pathname);
  Q(() => {
    const r = e.current !== t.pathname, n = t.hash !== "";
    r && !n && window.scrollTo(0, 0), e.current = t.pathname;
  }, [t.pathname, t.hash]);
}, Rs = ({
  icon: t
}) => typeof t == "string" ? /* @__PURE__ */ s.jsx(
  "img",
  {
    src: `https://cdn.simpleicons.org/${t}/000000/ffffff`,
    className: "size-5",
    alt: t
  }
) : t, _s = (t) => /^https?:/.test(t), Ds = () => {
  var r;
  const { page: t } = Pn(), e = t == null ? void 0 : t.footer;
  return e ? /* @__PURE__ */ s.jsx("footer", { className: "border-t bg-background", children: /* @__PURE__ */ s.jsxs("div", { className: "mx-auto max-w-screen-2xl px-4 lg:px-8 py-8 pt-20", children: [
    /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: O("flex flex-row gap-8", {
          "justify-center": !e.position || e.position === "center",
          "justify-start": e.position === "start",
          "justify-end": e.position === "end"
        }),
        children: [
          /* @__PURE__ */ s.jsx(_, { name: "footer-before" }),
          e.columns && /* @__PURE__ */ s.jsx(
            "div",
            {
              className: "w-full md:max-w-screen-md grid grid-cols-[1fr_1fr] gap-8 md:grid-cols-[repeat(var(--columns),minmax(0,1fr))]",
              style: { "--columns": e.columns.length },
              children: e.columns.map((n) => /* @__PURE__ */ s.jsxs(
                "div",
                {
                  className: O({
                    "justify-self-center": !n.position || n.position === "center",
                    "justify-self-start": n.position === "start",
                    "justify-self-end": n.position === "end"
                  }),
                  children: [
                    /* @__PURE__ */ s.jsx("span", { className: "text-sm font-semibold", children: n.title }),
                    /* @__PURE__ */ s.jsx("ul", { className: "mt-4 space-y-2", children: n.links.map((a, i) => {
                      const o = "flex flex-row gap-1 items-center text-sm text-muted-foreground hover:text-accent-foreground";
                      return /* @__PURE__ */ s.jsx("li", { children: _s(a.href) ? /* @__PURE__ */ s.jsxs(
                        "a",
                        {
                          href: a.href,
                          target: "_blank",
                          rel: "noopener noreferrer",
                          className: o,
                          children: [
                            /* @__PURE__ */ s.jsx("span", { children: a.label }),
                            /* @__PURE__ */ s.jsx(Dr, { size: 12 })
                          ]
                        }
                      ) : /* @__PURE__ */ s.jsx(
                        Br,
                        {
                          to: a.href + i,
                          className: o,
                          children: /* @__PURE__ */ s.jsx("span", { children: a.label })
                        }
                      ) }, a.href + i);
                    }) })
                  ]
                },
                n.title
              ))
            }
          ),
          /* @__PURE__ */ s.jsx(_, { name: "footer-after" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: O(
          "flex items-center justify-between",
          e.columns && "border-t mt-8 pt-8"
        ),
        children: [
          e.logo && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsx(
              "img",
              {
                src: e.logo.src.light,
                alt: e.logo.alt,
                className: "w-8 dark:hidden",
                style: { width: e.logo.width }
              }
            ),
            /* @__PURE__ */ s.jsx(
              "img",
              {
                src: e.logo.src.dark,
                alt: e.logo.alt,
                className: "w-8 hidden dark:block",
                style: { width: e.logo.width }
              }
            )
          ] }),
          e.copyright && /* @__PURE__ */ s.jsx("p", { className: "text-sm text-muted-foreground", children: e.copyright }),
          /* @__PURE__ */ s.jsx("div", { className: "flex items-center gap-2", children: (r = e.social) == null ? void 0 : r.map((n) => /* @__PURE__ */ s.jsxs(
            "a",
            {
              href: n.href,
              target: "_blank",
              rel: "noopener noreferrer",
              className: "w-auto gap-2 flex text-muted-foreground hover:text-accent-foreground",
              children: [
                /* @__PURE__ */ s.jsx(Rs, { icon: n.icon }),
                n.label
              ]
            },
            n.href
          )) })
        ]
      }
    )
  ] }) }) : null;
};
function qs({
  className: t,
  ...e
}) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      className: O("animate-pulse rounded-md bg-muted", t),
      ...e
    }
  );
}
const Ze = {
  info: "bg-blue-500",
  note: "bg-gray-500",
  tip: "bg-green-600",
  caution: "bg-orange-500",
  danger: "bg-rose-500"
}, $s = () => {
  const { page: t } = F(), [e, r] = J(!0);
  if (!(t != null && t.banner) || !e)
    return /* @__PURE__ */ s.jsx("style", { children: ":root { --banner-height: 0px; }" });
  const n = t.banner.color && t.banner.color in Ze ? Ze[t.banner.color] : t.banner.color ? void 0 : "bg-primary", a = n ? {} : { backgroundColor: t.banner.color };
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: O(
        "relative text-primary-foreground text-sm font-medium px-4 py-2 flex gap-2 items-center",
        n
      ),
      "data-pagefind-ignore": "all",
      style: a,
      children: [
        /* @__PURE__ */ s.jsx("div", { className: "w-full", children: t.banner.message }),
        t.banner.dismissible && /* @__PURE__ */ s.jsx(
          "button",
          {
            type: "button",
            className: "md:absolute md:right-4 -m-1.5 p-1.5 hover:bg-accent-foreground/10 rounded-md",
            onClick: () => r(!1),
            children: /* @__PURE__ */ s.jsx(qr, { size: 16 })
          }
        )
      ]
    }
  );
}, Ct = (t) => /* @__PURE__ */ s.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132 100",
    fill: "none",
    ...t,
    children: [
      /* @__PURE__ */ s.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M80.092 2.963A4.66 4.66 0 0 1 84.449 0h34.049c6.325 0 10.835 6.135 8.948 12.172L116.653 46.71a4.688 4.688 0 0 1-4.474 3.29H75c-5.178 0-7.813 4.687-9.375 9.374-1.288 3.864-11.07 28.963-14.467 37.662A4.66 4.66 0 0 1 46.801 100H12.75c-6.324 0-10.834-6.134-8.947-12.171l10.793-34.54A4.688 4.688 0 0 1 19.071 50H56.25c5.178 0 7.813-4.687 9.375-9.375 1.288-3.864 11.07-28.962 14.467-37.662Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M83.54 57.813a7.813 7.813 0 0 0-7.316 5.07L63.888 95.777c-.766 2.043.744 4.222 2.926 4.222h36.828c5.211 0 9.875-3.232 11.704-8.11l8.821-23.522c1.915-5.107-1.861-10.555-7.315-10.555H83.539ZM29.17 0a12.5 12.5 0 0 0-11.704 8.111l-8.82 23.521c-1.915 5.107 1.86 10.556 7.315 10.556h33.312a7.813 7.813 0 0 0 7.316-5.07L68.924 4.223C69.691 2.18 68.18 0 65.998 0H29.17Z"
        }
      )
    ]
  }
);
Ct.displayName = "ZudokuLogo";
const Nt = ({ className: t }) => /* @__PURE__ */ s.jsxs(
  "a",
  {
    href: "https://zudoku.dev",
    target: "_blank",
    rel: "noopener noreferrer",
    className: O(
      "flex justify-between items-center w-full border border-transparent hover:border-border rounded-full hover:shadow-sm h-7 px-3 text-nowrap hover:bg-muted/80 transition-all",
      t
    ),
    children: [
      /* @__PURE__ */ s.jsxs("div", { className: "opacity-70 hover:opacity-100 transition-opacity gap-1.5 text-[11px] font-medium rounded-full h-7 flex items-center text-nowrap", children: [
        /* @__PURE__ */ s.jsx(Ct, { className: "w-3.5 h-3.5 dark:fill-white" }),
        "powered by ",
        "Zudoku"
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: "text-xs font-medium opacity-70 hover:text-foreground transition-colors cursor-pointer", children: /* @__PURE__ */ s.jsx($r, { size: 12, absoluteStrokeWidth: !0, strokeWidth: 1.5 }) })
    ]
  }
);
function Is() {
  const t = navigator.userAgent.toLowerCase();
  if (t.includes("win")) return "Windows";
  if (t.includes("mac")) return "macOS";
  if (t.includes("linux")) return "Linux";
}
const Et = ({ className: t }) => {
  const e = F(), [r, n] = J(!1), a = W(() => n(!1), []);
  Q(() => {
    if (r)
      return;
    function o(f) {
      f.key === "k" && (f.metaKey || f.ctrlKey) && (f.preventDefault(), n(!0));
    }
    return window.addEventListener("keydown", o), () => {
      window.removeEventListener("keydown", o);
    };
  }, [r, n]);
  const i = e.plugins.find(Xr);
  return i ? /* @__PURE__ */ s.jsxs("div", { className: t, children: [
    /* @__PURE__ */ s.jsxs(
      "button",
      {
        type: "button",
        onClick: () => n(!0),
        className: "flex items-center border border-input hover:bg-accent hover:text-accent-foreground p-4 relative h-8 justify-start rounded-lg bg-background text-sm text-muted-foreground shadow-none w-full sm:w-72",
        children: [
          /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2 flex-grow", children: [
            /* @__PURE__ */ s.jsx(Ir, { size: 14 }),
            "Search"
          ] }),
          /* @__PURE__ */ s.jsx(xe, { children: /* @__PURE__ */ s.jsx(Fs, {}) })
        ]
      }
    ),
    /* @__PURE__ */ s.jsx(Oe, { fallback: null, children: i.renderSearch({
      isOpen: r,
      onClose: a
    }) })
  ] }) : null;
}, Fs = () => {
  const t = Is();
  return /* @__PURE__ */ s.jsxs("kbd", { className: "absolute right-1.5 hidden h-5 select-none items-center gap-1 rounded-sm border bg-muted px-1.5 font-mono text-[11px] font-medium opacity-100 sm:flex", children: [
    t === "macOS" ? "⌘" : "Ctrl",
    "+K"
  ] });
}, Tt = () => {
  const { resolvedTheme: t, setTheme: e } = ct();
  return /* @__PURE__ */ s.jsx(xe, { fallback: /* @__PURE__ */ s.jsx(Se, { variant: "ghost", size: "icon" }), children: /* @__PURE__ */ s.jsxs(
    "button",
    {
      type: "button",
      className: "flex rounded-full border p-0.5 gap-0.5 group",
      onClick: () => e(t === "dark" ? "light" : "dark"),
      "aria-label": t === "dark" ? "Switch to light mode" : "Switch to dark mode",
      children: [
        /* @__PURE__ */ s.jsx(
          "div",
          {
            className: O(
              "border border-transparent rounded-full p-0.5 [&>svg>circle]:transition-colors [&>svg>path]:transition-transform transition-all [&>svg>path]:duration-200 [&>svg>circle]:duration-500 [&>svg>circle]:fill-transparent",
              t === "light" && "border-border bg-muted",
              t === "dark" && "group-hover:[&>svg>path]:scale-110 group-hover:[&>svg>path]:-translate-x-[1px] group-hover:[&>svg>path]:-translate-y-[1px] group-hover:rotate-[15deg] "
            ),
            children: /* @__PURE__ */ s.jsx(Fr, { size: 16 })
          }
        ),
        /* @__PURE__ */ s.jsx(
          "div",
          {
            className: O(
              "border border-transparent rounded-full p-0.5 transition-transform transform-gpu duration-500",
              t === "dark" && "border-border bg-muted [&>svg>path]:fill-white [&>svg>path]:stroke-transparent",
              t === "light" && "group-hover:rotate-[-10deg] [&>svg>path]:stroke-currentColor"
            ),
            children: /* @__PURE__ */ s.jsx(Qr, { size: 16 })
          }
        )
      ]
    }
  ) });
};
function me() {
  return me = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, me.apply(null, arguments);
}
var ue = { exports: {} }, w = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ve;
function Qs() {
  if (Ve) return w;
  Ve = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, n = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, o = t ? Symbol.for("react.provider") : 60109, f = t ? Symbol.for("react.context") : 60110, h = t ? Symbol.for("react.async_mode") : 60111, l = t ? Symbol.for("react.concurrent_mode") : 60111, b = t ? Symbol.for("react.forward_ref") : 60112, v = t ? Symbol.for("react.suspense") : 60113, g = t ? Symbol.for("react.suspense_list") : 60120, y = t ? Symbol.for("react.memo") : 60115, m = t ? Symbol.for("react.lazy") : 60116, p = t ? Symbol.for("react.block") : 60121, C = t ? Symbol.for("react.fundamental") : 60117, E = t ? Symbol.for("react.responder") : 60118, T = t ? Symbol.for("react.scope") : 60119;
  function x(c) {
    if (typeof c == "object" && c !== null) {
      var S = c.$$typeof;
      switch (S) {
        case e:
          switch (c = c.type, c) {
            case h:
            case l:
            case n:
            case i:
            case a:
            case v:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case f:
                case b:
                case m:
                case y:
                case o:
                  return c;
                default:
                  return S;
              }
          }
        case r:
          return S;
      }
    }
  }
  function j(c) {
    return x(c) === l;
  }
  return w.AsyncMode = h, w.ConcurrentMode = l, w.ContextConsumer = f, w.ContextProvider = o, w.Element = e, w.ForwardRef = b, w.Fragment = n, w.Lazy = m, w.Memo = y, w.Portal = r, w.Profiler = i, w.StrictMode = a, w.Suspense = v, w.isAsyncMode = function(c) {
    return j(c) || x(c) === h;
  }, w.isConcurrentMode = j, w.isContextConsumer = function(c) {
    return x(c) === f;
  }, w.isContextProvider = function(c) {
    return x(c) === o;
  }, w.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === e;
  }, w.isForwardRef = function(c) {
    return x(c) === b;
  }, w.isFragment = function(c) {
    return x(c) === n;
  }, w.isLazy = function(c) {
    return x(c) === m;
  }, w.isMemo = function(c) {
    return x(c) === y;
  }, w.isPortal = function(c) {
    return x(c) === r;
  }, w.isProfiler = function(c) {
    return x(c) === i;
  }, w.isStrictMode = function(c) {
    return x(c) === a;
  }, w.isSuspense = function(c) {
    return x(c) === v;
  }, w.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === n || c === l || c === i || c === a || c === v || c === g || typeof c == "object" && c !== null && (c.$$typeof === m || c.$$typeof === y || c.$$typeof === o || c.$$typeof === f || c.$$typeof === b || c.$$typeof === C || c.$$typeof === E || c.$$typeof === T || c.$$typeof === p);
  }, w.typeOf = x, w;
}
var P = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var We;
function zs() {
  return We || (We = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, n = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, o = t ? Symbol.for("react.provider") : 60109, f = t ? Symbol.for("react.context") : 60110, h = t ? Symbol.for("react.async_mode") : 60111, l = t ? Symbol.for("react.concurrent_mode") : 60111, b = t ? Symbol.for("react.forward_ref") : 60112, v = t ? Symbol.for("react.suspense") : 60113, g = t ? Symbol.for("react.suspense_list") : 60120, y = t ? Symbol.for("react.memo") : 60115, m = t ? Symbol.for("react.lazy") : 60116, p = t ? Symbol.for("react.block") : 60121, C = t ? Symbol.for("react.fundamental") : 60117, E = t ? Symbol.for("react.responder") : 60118, T = t ? Symbol.for("react.scope") : 60119;
    function x(u) {
      return typeof u == "string" || typeof u == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      u === n || u === l || u === i || u === a || u === v || u === g || typeof u == "object" && u !== null && (u.$$typeof === m || u.$$typeof === y || u.$$typeof === o || u.$$typeof === f || u.$$typeof === b || u.$$typeof === C || u.$$typeof === E || u.$$typeof === T || u.$$typeof === p);
    }
    function j(u) {
      if (typeof u == "object" && u !== null) {
        var ye = u.$$typeof;
        switch (ye) {
          case e:
            var ie = u.type;
            switch (ie) {
              case h:
              case l:
              case n:
              case i:
              case a:
              case v:
                return ie;
              default:
                var Re = ie && ie.$$typeof;
                switch (Re) {
                  case f:
                  case b:
                  case m:
                  case y:
                  case o:
                    return Re;
                  default:
                    return ye;
                }
            }
          case r:
            return ye;
        }
      }
    }
    var c = h, S = l, D = f, q = o, L = e, U = b, ve = n, X = m, zt = y, Lt = r, Bt = i, Ht = a, Kt = v, Ae = !1;
    function Ut(u) {
      return Ae || (Ae = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ke(u) || j(u) === h;
    }
    function ke(u) {
      return j(u) === l;
    }
    function Yt(u) {
      return j(u) === f;
    }
    function Zt(u) {
      return j(u) === o;
    }
    function Vt(u) {
      return typeof u == "object" && u !== null && u.$$typeof === e;
    }
    function Wt(u) {
      return j(u) === b;
    }
    function Gt(u) {
      return j(u) === n;
    }
    function Xt(u) {
      return j(u) === m;
    }
    function Jt(u) {
      return j(u) === y;
    }
    function er(u) {
      return j(u) === r;
    }
    function tr(u) {
      return j(u) === i;
    }
    function rr(u) {
      return j(u) === a;
    }
    function sr(u) {
      return j(u) === v;
    }
    P.AsyncMode = c, P.ConcurrentMode = S, P.ContextConsumer = D, P.ContextProvider = q, P.Element = L, P.ForwardRef = U, P.Fragment = ve, P.Lazy = X, P.Memo = zt, P.Portal = Lt, P.Profiler = Bt, P.StrictMode = Ht, P.Suspense = Kt, P.isAsyncMode = Ut, P.isConcurrentMode = ke, P.isContextConsumer = Yt, P.isContextProvider = Zt, P.isElement = Vt, P.isForwardRef = Wt, P.isFragment = Gt, P.isLazy = Xt, P.isMemo = Jt, P.isPortal = er, P.isProfiler = tr, P.isStrictMode = rr, P.isSuspense = sr, P.isValidElementType = x, P.typeOf = j;
  }()), P;
}
var Ge;
function Ls() {
  return Ge || (Ge = 1, process.env.NODE_ENV === "production" ? ue.exports = Qs() : ue.exports = zs()), ue.exports;
}
var we, Xe;
function Bs() {
  if (Xe) return we;
  Xe = 1;
  var t = Ls(), e = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, r = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, n = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, a = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, i = {};
  i[t.ForwardRef] = n, i[t.Memo] = a;
  function o(m) {
    return t.isMemo(m) ? a : i[m.$$typeof] || e;
  }
  var f = Object.defineProperty, h = Object.getOwnPropertyNames, l = Object.getOwnPropertySymbols, b = Object.getOwnPropertyDescriptor, v = Object.getPrototypeOf, g = Object.prototype;
  function y(m, p, C) {
    if (typeof p != "string") {
      if (g) {
        var E = v(p);
        E && E !== g && y(m, E, C);
      }
      var T = h(p);
      l && (T = T.concat(l(p)));
      for (var x = o(m), j = o(p), c = 0; c < T.length; ++c) {
        var S = T[c];
        if (!r[S] && !(C && C[S]) && !(j && j[S]) && !(x && x[S])) {
          var D = b(p, S);
          try {
            f(m, S, D);
          } catch {
          }
        }
      }
    }
    return m;
  }
  return we = y, we;
}
Bs();
var Mt = function(e, r, n) {
  return e = e <= n ? e : n, e = e >= r ? e : r, e;
}, Hs = function() {
  var e = !1, r = [], n = function() {
    e = !0;
    var f = r.shift();
    if (f)
      return f(n);
    e = !1;
  }, a = function() {
    e = !1, r = [];
  }, i = function(f) {
    r.push(f), !e && r.length === 1 && n();
  };
  return {
    clear: a,
    enqueue: i
  };
}, Ks = function() {
  var e, r = function() {
    e && window.cancelAnimationFrame(e);
  }, n = function(i, o) {
    var f, h, l = function(v) {
      if (h = h || v, f = v - h, f > o) {
        i();
        return;
      }
      e = window.requestAnimationFrame(l);
    };
    e = window.requestAnimationFrame(l);
  };
  return {
    cancel: r,
    schedule: n
  };
}, Us = function(e) {
  var r = 0;
  return e >= 0 && e < 0.2 ? r = 0.1 : e >= 0.2 && e < 0.5 ? r = 0.04 : e >= 0.5 && e < 0.8 ? r = 0.02 : e >= 0.8 && e < 0.99 && (r = 5e-3), Mt(e + r, 0, 0.994);
}, Je = function(e) {
  Q(e, []);
}, Ys = function(e) {
  return ++e % 1e6;
}, Zs = function() {
  var e = J(0), r = e[1];
  return W(function() {
    return r(Ys);
  }, []);
}, Vs = function(e) {
  e === void 0 && (e = {});
  var r = Zs(), n = G(me({}, e)), a = W(function() {
    return n.current;
  }, []), i = W(function(o) {
    o && (Object.assign(n.current, o), r());
  }, []);
  return [a, i];
}, Ws = function() {
  var e = G(!0);
  return e.current ? (e.current = !1, !0) : e.current;
}, et = function(e, r) {
  var n = Ws();
  Q(function() {
    if (!n)
      return e();
  }, r);
}, Ot = function() {
}, tt = {
  isFinished: !0,
  progress: 0,
  sideEffect: Ot
}, Gs = function(e) {
  var r = e === void 0 ? {} : e, n = r.animationDuration, a = n === void 0 ? 200 : n, i = r.incrementDuration, o = i === void 0 ? 800 : i, f = r.isAnimating, h = f === void 0 ? !1 : f, l = r.minimum, b = l === void 0 ? 0.08 : l, v = Vs(tt), g = v[0], y = v[1], m = G(null), p = G(null);
  Je(function() {
    m.current = Hs(), p.current = Ks();
  });
  var C = W(function() {
    var S, D;
    (S = p.current) == null || S.cancel(), (D = m.current) == null || D.clear();
  }, []), E = W(function(S) {
    var D;
    if (S = Mt(S, b, 1), S === 1) {
      var q, L;
      C(), (q = m.current) == null || q.enqueue(function(U) {
        y({
          progress: S,
          sideEffect: function() {
            var X;
            return (X = p.current) == null ? void 0 : X.schedule(U, a);
          }
        });
      }), (L = m.current) == null || L.enqueue(function() {
        y({
          isFinished: !0,
          sideEffect: C
        });
      });
      return;
    }
    (D = m.current) == null || D.enqueue(function(U) {
      y({
        isFinished: !1,
        progress: S,
        sideEffect: function() {
          var X;
          return (X = p.current) == null ? void 0 : X.schedule(U, a);
        }
      });
    });
  }, [a, C, b, m, y, p]), T = W(function() {
    E(Us(g().progress));
  }, [g, E]), x = W(function() {
    var S = function() {
      var q;
      T(), (q = m.current) == null || q.enqueue(function(L) {
        var U;
        (U = p.current) == null || U.schedule(function() {
          S(), L();
        }, o);
      });
    };
    S();
  }, [o, m, p, T]), j = G(Ot), c = g().sideEffect;
  return Q(function() {
    j.current = T;
  }), Je(function() {
    return h && x(), C;
  }), et(function() {
    g().sideEffect();
  }, [g, c]), et(function() {
    h ? y(me({}, tt, {
      sideEffect: x
    })) : E(1);
  }, [h, E, y, x]), {
    animationDuration: a,
    isFinished: g().isFinished,
    progress: g().progress
  };
};
const At = (t) => (e) => e.display === "hide" ? !1 : e.display === "auth" && t || e.display === "anon" && !t || !e.display || e.display === "always", kt = () => {
  const e = ge().state === "loading", [r, n] = J(!1);
  Q(() => {
    const o = setTimeout(() => n(e), 100);
    return () => clearTimeout(o);
  }, [e]);
  const { isFinished: a, progress: i } = Gs({ isAnimating: r });
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      className: "absolute w-0 left-0 right-0 bottom-[-1px] h-[2px] bg-primary transition-all duration-300 ease-in-out",
      style: {
        opacity: a ? 0 : 1,
        width: a ? 0 : `${i * 100}%`
      }
    }
  );
}, Xs = () => {
  const { topNavigation: t } = F(), { isAuthenticated: e } = ae(), r = t.filter(At(e));
  return r.length === 0 ? /* @__PURE__ */ s.jsx("style", { children: ":root { --top-nav-height: 0px; }" }) : /* @__PURE__ */ s.jsxs(Oe, { children: [
    /* @__PURE__ */ s.jsxs("div", { className: "items-center justify-between px-8 h-[--top-nav-height] hidden lg:flex text-sm relative", children: [
      /* @__PURE__ */ s.jsx("nav", { className: "text-sm", children: /* @__PURE__ */ s.jsx("ul", { className: "flex flex-row items-center gap-8", children: r.map((n) => /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(Rt, { ...n }) }, n.id)) }) }),
      /* @__PURE__ */ s.jsx(_, { name: "top-navigation-side" })
    ] }),
    /* @__PURE__ */ s.jsx(kt, {})
  ] });
}, Rt = ({
  id: t,
  label: e,
  default: r
}) => {
  var l;
  const { sidebars: n } = F(), a = n[t], i = mt(), o = !!ge().location, f = ((l = i.topNavItem) == null ? void 0 : l.id) === t && !o, h = r ?? (a ? yr(a, (b) => {
    if (b.type === "doc") return ee(b.id);
  }) : ee(t)) ?? ee(t);
  return (
    // We don't use isActive here because it has to be inside the sidebar,
    // the top nav id doesn't necessarily start with the sidebar id
    /* @__PURE__ */ s.jsx(
      ur,
      {
        className: ({ isPending: b }) => vs(
          "block lg:py-3.5 font-medium -mb-px",
          f || b ? "border-primary text-foreground" : "border-transparent text-foreground/75 hover:text-foreground hover:border-accent-foreground/25"
        ),
        to: h,
        children: e
      }
    )
  );
}, Js = () => {
  var i;
  const { topNavigation: t, options: e } = F(), { isAuthenticated: r } = ae(), [n, a] = J(!1);
  return /* @__PURE__ */ s.jsxs(
    gs,
    {
      direction: "right",
      open: n,
      onOpenChange: (o) => a(o),
      children: [
        /* @__PURE__ */ s.jsxs("div", { className: "flex lg:hidden justify-self-end", children: [
          /* @__PURE__ */ s.jsx(xs, { className: "lg:hidden", children: /* @__PURE__ */ s.jsx(zr, { size: 22 }) }),
          /* @__PURE__ */ s.jsx(kt, {})
        ] }),
        /* @__PURE__ */ s.jsx(
          jt,
          {
            className: "lg:hidden h-[100dvh] right-0 left-auto w-[320px] rounded-none",
            "aria-describedby": void 0,
            children: /* @__PURE__ */ s.jsxs("div", { className: "p-4 overflow-y-auto overscroll-none h-full flex flex-col justify-between", children: [
              /* @__PURE__ */ s.jsxs("div", { children: [
                /* @__PURE__ */ s.jsx(bt, { children: /* @__PURE__ */ s.jsx(wt, { children: "Navigation" }) }),
                /* @__PURE__ */ s.jsx(Et, { className: "flex p-4" }),
                /* @__PURE__ */ s.jsxs("ul", { className: "flex flex-col items-center gap-4 p-4", children: [
                  /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(Tt, {}) }),
                  t.filter(At(r)).map((o) => /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx("button", { type: "button", onClick: () => a(!1), children: /* @__PURE__ */ s.jsx(Rt, { ...o }) }) }, o.label))
                ] })
              ] }),
              ((i = e.page) == null ? void 0 : i.showPoweredBy) !== !1 && /* @__PURE__ */ s.jsx(Nt, { className: "flex-grow-0 justify-center gap-1" })
            ] })
          }
        )
      ]
    }
  );
}, fe = ({ item: t }) => t.children ? /* @__PURE__ */ s.jsxs(ds, { children: [
  /* @__PURE__ */ s.jsx(fs, { children: t.label }),
  /* @__PURE__ */ s.jsx(hs, { children: /* @__PURE__ */ s.jsx(ms, { children: t.children.map((e, r) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ s.jsx(fe, { item: e }, r)
  )) }) })
] }, t.label) : /* @__PURE__ */ s.jsx(Te, { to: t.path ?? "", children: /* @__PURE__ */ s.jsxs(ps, { className: "flex gap-2", children: [
  t.icon && /* @__PURE__ */ s.jsx(t.icon, { size: 16, strokeWidth: 1, absoluteStrokeWidth: !0 }),
  t.label
] }, t.label) }), _t = vt(function() {
  const e = ae(), { isAuthenticated: r, profile: n, isAuthEnabled: a } = ae(), i = F(), { page: o, plugins: f } = i, h = f.filter((l) => Jr(l)).flatMap((l) => l.getProfileMenuItems(i)).sort((l) => l.weight ?? 0);
  return /* @__PURE__ */ s.jsxs("header", { className: "sticky lg:top-0 z-10 bg-background/80 backdrop-blur w-full", children: [
    /* @__PURE__ */ s.jsx($s, {}),
    /* @__PURE__ */ s.jsx("div", { className: "border-b", children: /* @__PURE__ */ s.jsxs("div", { className: "max-w-screen-2xl mx-auto flex relative items-center justify-between px-4 lg:px-8 h-[--top-header-height] border-transparent", children: [
      /* @__PURE__ */ s.jsx("div", { className: "flex", children: /* @__PURE__ */ s.jsx(Te, { to: "/", children: /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3.5", children: [
        (o == null ? void 0 : o.logo) && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          /* @__PURE__ */ s.jsx(
            "img",
            {
              src: /https?:\/\//.test(o.logo.src.light) ? o.logo.src.light : ee(
                "/",
                o.logo.src.light
              ),
              alt: o.logo.alt ?? o.pageTitle,
              style: { width: o.logo.width },
              className: "h-10 dark:hidden",
              loading: "lazy"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "img",
            {
              src: /https?:\/\//.test(o.logo.src.dark) ? o.logo.src.dark : ee(
                "/",
                o.logo.src.dark
              ),
              alt: o.logo.alt ?? o.pageTitle,
              style: { width: o.logo.width },
              className: "h-10 hidden dark:block",
              loading: "lazy"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx("span", { className: "font-bold text-2xl text-foreground/85 tracking-wide", children: o == null ? void 0 : o.pageTitle })
      ] }) }) }),
      /* @__PURE__ */ s.jsx("div", { className: "absolute inset-x-0 justify-center items-center hidden lg:flex w-full pointer-events-none", children: /* @__PURE__ */ s.jsx(Et, { className: "pointer-events-auto" }) }),
      /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-8", children: [
        /* @__PURE__ */ s.jsx(Js, {}),
        /* @__PURE__ */ s.jsxs("div", { className: "hidden lg:flex items-center justify-self-end text-sm gap-2", children: [
          /* @__PURE__ */ s.jsx(_, { name: "head-navigation-start" }),
          a && /* @__PURE__ */ s.jsx(
            xe,
            {
              fallback: /* @__PURE__ */ s.jsx(qs, { className: "rounded h-5 w-24 mr-4" }),
              children: r ? Object.values(h).length > 0 && /* @__PURE__ */ s.jsxs(is, { modal: !1, children: [
                /* @__PURE__ */ s.jsx(cs, { asChild: !0, children: /* @__PURE__ */ s.jsx(Se, { variant: "ghost", children: n != null && n.name ? `${n.name}` : "My Account" }) }),
                /* @__PURE__ */ s.jsxs(ls, { className: "w-56", children: [
                  /* @__PURE__ */ s.jsxs(us, { children: [
                    n != null && n.name ? `${n.name}` : "My Account",
                    (n == null ? void 0 : n.email) && /* @__PURE__ */ s.jsx("div", { className: "font-normal text-muted-foreground", children: n.email })
                  ] }),
                  h.filter((l) => l.category === "top").length > 0 && /* @__PURE__ */ s.jsx(je, {}),
                  h.filter((l) => l.category === "top").map((l) => /* @__PURE__ */ s.jsx(fe, { item: l }, l.label)),
                  h.filter(
                    (l) => !l.category || l.category === "middle"
                  ).length > 0 && /* @__PURE__ */ s.jsx(je, {}),
                  h.filter(
                    (l) => !l.category || l.category === "middle"
                  ).map((l) => /* @__PURE__ */ s.jsx(fe, { item: l }, l.label)),
                  h.filter((l) => l.category === "bottom").length > 0 && /* @__PURE__ */ s.jsx(je, {}),
                  h.filter((l) => l.category === "bottom").map((l) => /* @__PURE__ */ s.jsx(fe, { item: l }, l.label))
                ] })
              ] }) : /* @__PURE__ */ s.jsx(Se, { variant: "ghost", onClick: () => e.login(), children: "Login" })
            }
          ),
          /* @__PURE__ */ s.jsx(_, { name: "head-navigation-end" }),
          /* @__PURE__ */ s.jsx(Tt, {})
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ s.jsx("div", { className: "border-b hidden lg:block", children: /* @__PURE__ */ s.jsxs("div", { className: "max-w-screen-2xl mx-auto border-transparent", children: [
      /* @__PURE__ */ s.jsx(_, { name: "top-navigation-before" }),
      /* @__PURE__ */ s.jsx(Xs, {}),
      /* @__PURE__ */ s.jsx(_, { name: "top-navigation-after" })
    ] }) })
  ] });
}), Dt = ({
  shouldScaleBackground: t = !0,
  ...e
}) => /* @__PURE__ */ s.jsx(
  z.Root,
  {
    shouldScaleBackground: t,
    ...e
  }
);
Dt.displayName = "Drawer";
const en = z.Trigger, tn = z.Portal, qt = K.forwardRef(({ className: t, ...e }, r) => /* @__PURE__ */ s.jsx(
  z.Overlay,
  {
    ref: r,
    className: O("fixed inset-0 z-50 bg-black/80", t),
    ...e
  }
));
qt.displayName = z.Overlay.displayName;
const rn = K.forwardRef(
  ({ className: t, children: e, hideBar: r = !0, ...n }, a) => /* @__PURE__ */ s.jsxs(tn, { children: [
    /* @__PURE__ */ s.jsx(qt, {}),
    /* @__PURE__ */ s.jsxs(
      z.Content,
      {
        ref: a,
        className: O(
          "fixed inset-x-0 bottom-0 z-50 mt-24 flex h-auto flex-col rounded-t-[10px] border bg-background",
          t
        ),
        ...n,
        children: [
          !r && /* @__PURE__ */ s.jsx("div", { className: "mx-auto mt-4 h-2 w-[100px] rounded-full bg-muted" }),
          e
        ]
      }
    )
  ] })
);
rn.displayName = "DrawerContent";
const sn = K.forwardRef(({ className: t, ...e }, r) => /* @__PURE__ */ s.jsx(
  z.Title,
  {
    ref: r,
    className: O(
      "text-lg font-semibold leading-none tracking-tight",
      t
    ),
    ...e
  }
));
sn.displayName = z.Title.displayName;
const nn = K.forwardRef(({ className: t, ...e }, r) => /* @__PURE__ */ s.jsx(
  z.Description,
  {
    ref: r,
    className: O("text-sm text-muted-foreground", t),
    ...e
  }
));
nn.displayName = z.Description.displayName;
const $t = ({
  children: t,
  className: e
}) => {
  var a;
  const { options: r } = F(), n = G(null);
  return Q(() => {
    var o;
    const i = (o = n.current) == null ? void 0 : o.querySelector('[aria-current="page"]');
    Hr(i ?? null);
  }, []), /* @__PURE__ */ s.jsxs("div", { className: "grid sticky top-[--header-height] lg:h-[calc(100vh-var(--header-height))] grid-rows-[1fr_min-content] border-r", children: [
    /* @__PURE__ */ s.jsx(
      "nav",
      {
        ref: n,
        className: O(
          "hidden max-w-[calc(var(--side-nav-width)+var(--padding-nav-item))] lg:flex scrollbar flex-col overflow-y-auto shrink-0 text-sm pe-3 ps-4 lg:ps-8",
          "-mx-[--padding-nav-item] pb-[8vh] pt-[--padding-content-top] scroll-pt-2 gap-1",
          // Revert the padding/margin on the first child
          "-mt-2.5",
          e
        ),
        style: {
          maskImage: "linear-gradient(180deg, transparent 1%, rgba(0, 0, 0, 1) 20px, rgba(0, 0, 0, 1) 90%, transparent 99%)"
        },
        children: t
      }
    ),
    /* @__PURE__ */ s.jsx("div", { className: "bg-background border-t p-2 mx-5  gap-2 items-center mt-2 drop-shadow-[0_-3px_1px_rgba(0,0,0,0.015)] hidden lg:[&:has(>_:nth-child(1):last-child)]:flex", children: ((a = r.page) == null ? void 0 : a.showPoweredBy) !== !1 && /* @__PURE__ */ s.jsx(Nt, {}) })
  ] });
};
$t.displayName = "SidebarWrapper";
const an = ({
  onRequestClose: t,
  sidebar: e
}) => /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
  /* @__PURE__ */ s.jsxs($t, { children: [
    /* @__PURE__ */ s.jsx(_, { name: "zudoku-before-navigation" }),
    e.map((r) => /* @__PURE__ */ s.jsx(
      Be,
      {
        item: r
      },
      ("id" in r ? r.id : "") + ("href" in r ? r.href : "") + r.label
    )),
    /* @__PURE__ */ s.jsx(_, { name: "zudoku-after-navigation" })
  ] }),
  /* @__PURE__ */ s.jsx(
    jt,
    {
      className: "lg:hidden h-[100dvh] left-0 w-[320px] rounded-none",
      "aria-describedby": void 0,
      children: /* @__PURE__ */ s.jsxs("div", { className: "p-4 overflow-y-auto overscroll-none", children: [
        /* @__PURE__ */ s.jsx(bt, { children: /* @__PURE__ */ s.jsx(wt, { children: "Sidebar" }) }),
        e.map((r) => /* @__PURE__ */ s.jsx(
          Be,
          {
            item: r,
            onRequestClose: t
          },
          r.label
        ))
      ] })
    }
  )
] }), on = ({ children: t }) => {
  const [e, r] = J(!1), { sidebar: n } = mt(), a = n.length > 0, i = ge().state === "loading";
  return /* @__PURE__ */ s.jsxs(
    Dt,
    {
      direction: "left",
      open: e,
      onOpenChange: (o) => r(o),
      children: [
        a && /* @__PURE__ */ s.jsx(
          an,
          {
            onRequestClose: () => r(!1),
            sidebar: n
          }
        ),
        a && /* @__PURE__ */ s.jsx("div", { className: "lg:hidden -mx-4 px-4 py-2 sticky bg-background/80 backdrop-blur z-10 top-0 left-0 right-0 border-b", children: /* @__PURE__ */ s.jsxs(en, { className: "flex items-center gap-2 px-4", children: [
          /* @__PURE__ */ s.jsx(Lr, { size: 16, strokeWidth: 1.5 }),
          /* @__PURE__ */ s.jsx("span", { className: "text-sm", children: "Menu" })
        ] }) }),
        /* @__PURE__ */ s.jsxs(
          "main",
          {
            "data-pagefind-body": !0,
            className: O(
              "px-4 lg:pe-8 lg:px-8",
              !a && "col-span-full",
              i && "animate-pulse"
            ),
            children: [
              /* @__PURE__ */ s.jsx(_, { name: "zudoku-before-content" }),
              t,
              /* @__PURE__ */ s.jsx(_, { name: "zudoku-after-content" })
            ]
          }
        )
      ]
    }
  );
}, cn = () => /* @__PURE__ */ s.jsx("main", { className: "col-span-full row-span-full grid place-items-center", children: /* @__PURE__ */ s.jsx(yt, {}) }), ln = ({ children: t }) => {
  const { meta: e, authentication: r, options: n } = F(), a = pe();
  return Kr(), ks(), Q(() => {
    var i;
    (i = r == null ? void 0 : r.onPageLoad) == null || i.call(r);
  }, [r]), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    !1,
    /* @__PURE__ */ s.jsxs(Ee, { titleTemplate: e == null ? void 0 : e.title, children: [
      n.canonicalUrlOrigin && /* @__PURE__ */ s.jsx(
        "link",
        {
          rel: "canonical",
          href: ee(
            n.canonicalUrlOrigin,
            n.basePath,
            a.pathname
          )
        }
      ),
      (e == null ? void 0 : e.description) && /* @__PURE__ */ s.jsx("meta", { name: "description", content: e.description }),
      (e == null ? void 0 : e.favicon) && /* @__PURE__ */ s.jsx("link", { rel: "icon", href: e.favicon })
    ] }),
    /* @__PURE__ */ s.jsx(_, { name: "layout-before-head" }),
    /* @__PURE__ */ s.jsx(_t, {}),
    /* @__PURE__ */ s.jsx(_, { name: "layout-after-head" }),
    /* @__PURE__ */ s.jsx(
      "div",
      {
        className: O(
          "grid max-w-screen-2xl w-full lg:mx-auto",
          "has-[:only-child]:grid-rows-1 grid-rows-[0_min-content_1fr] lg:grid-rows-[min-content_1fr]",
          "grid-cols-1 lg:grid-cols-[var(--side-nav-width)_1fr]"
        ),
        children: /* @__PURE__ */ s.jsx(Oe, { fallback: /* @__PURE__ */ s.jsx(cn, {}), children: /* @__PURE__ */ s.jsx(on, { children: t ?? /* @__PURE__ */ s.jsx(lt, {}) }) })
      }
    ),
    /* @__PURE__ */ s.jsx(Ds, {})
  ] });
}, un = ({
  title: t = "An error occurred",
  message: e,
  category: r
}) => /* @__PURE__ */ s.jsxs("div", { className: Yr + " h-full pt-[--padding-content-top]", children: [
  r && /* @__PURE__ */ s.jsx(Gr, { children: r }),
  t && /* @__PURE__ */ s.jsx(Ur, { level: 1, className: "flex gap-3.5 items-center", children: t }),
  /* @__PURE__ */ s.jsx("p", { children: e })
] }), dn = (t) => {
  switch (t) {
    case 400:
      return {
        title: "Bad Request",
        message: "The request could not be understood by the server due to malformed syntax."
      };
    case 403:
      return {
        title: "Forbidden",
        message: "You don't have permission to access this resource."
      };
    case 404:
      return {
        title: "Not Found",
        message: "The requested resource could not be found."
      };
    case 405:
      return {
        title: "Method Not Allowed",
        message: "The request method is not supported for the requested resource."
      };
    case 414:
      return {
        title: "Request URI Too Large",
        message: "The request URI is too large."
      };
    case 416:
      return {
        title: "Range Not Satisfiable",
        message: "The server cannot satisfy the request range."
      };
    case 500:
      return {
        title: "Internal Server Error",
        message: "An unexpected error occurred while processing your request."
      };
    case 501:
      return {
        title: "Not Implemented",
        message: "The server does not support the functionality required to fulfill the request."
      };
    case 502:
      return {
        title: "Bad Gateway",
        message: "The server received an invalid response from the upstream server."
      };
    case 503:
      return {
        title: "Service Unavailable",
        message: "The server is temporarily unable to handle the request."
      };
    case 504:
      return {
        title: "Gateway Timeout",
        message: "The server did not receive a timely response from the upstream server."
      };
    default:
      return {
        title: "An error occurred",
        message: "Something went wrong while processing your request."
      };
  }
}, fn = ({ statusCode: t, message: e }) => {
  const r = dn(t);
  return /* @__PURE__ */ s.jsx(
    un,
    {
      title: r.title,
      message: e ?? r.message,
      category: t
    }
  );
}, hn = Me(null), Pe = {
  didCatch: !1,
  error: null
};
class mn extends Or {
  constructor(e) {
    super(e), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = Pe;
  }
  static getDerivedStateFromError(e) {
    return {
      didCatch: !0,
      error: e
    };
  }
  resetErrorBoundary() {
    const {
      error: e
    } = this.state;
    if (e !== null) {
      for (var r, n, a = arguments.length, i = new Array(a), o = 0; o < a; o++)
        i[o] = arguments[o];
      (r = (n = this.props).onReset) === null || r === void 0 || r.call(n, {
        args: i,
        reason: "imperative-api"
      }), this.setState(Pe);
    }
  }
  componentDidCatch(e, r) {
    var n, a;
    (n = (a = this.props).onError) === null || n === void 0 || n.call(a, e, r);
  }
  componentDidUpdate(e, r) {
    const {
      didCatch: n
    } = this.state, {
      resetKeys: a
    } = this.props;
    if (n && r.error !== null && pn(e.resetKeys, a)) {
      var i, o;
      (i = (o = this.props).onReset) === null || i === void 0 || i.call(o, {
        next: a,
        prev: e.resetKeys,
        reason: "keys"
      }), this.setState(Pe);
    }
  }
  render() {
    const {
      children: e,
      fallbackRender: r,
      FallbackComponent: n,
      fallback: a
    } = this.props, {
      didCatch: i,
      error: o
    } = this.state;
    let f = e;
    if (i) {
      const h = {
        error: o,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof r == "function")
        f = r(h);
      else if (n)
        f = Le(n, h);
      else if (a !== void 0)
        f = a;
      else
        throw o;
    }
    return Le(hn.Provider, {
      value: {
        didCatch: i,
        error: o,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, f);
  }
}
function pn() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return t.length !== e.length || t.some((r, n) => !Object.is(r, e[n]));
}
let gn = () => ({
  emit(t, ...e) {
    for (let r = this.events[t] || [], n = 0, a = r.length; n < a; n++)
      r[n](...e);
  },
  events: {},
  on(t, e) {
    var r;
    return ((r = this.events)[t] || (r[t] = [])).push(e), () => {
      var n;
      this.events[t] = (n = this.events[t]) == null ? void 0 : n.filter((a) => e !== a);
    };
  }
});
class xn {
  constructor(e, r) {
    A(this, "plugins");
    A(this, "sidebars");
    A(this, "topNavigation");
    A(this, "meta");
    A(this, "page");
    A(this, "authentication");
    A(this, "navigationPlugins");
    A(this, "emitter", gn());
    A(this, "initialize", async () => {
      await Promise.all(
        this.plugins.filter(rs).map((e) => {
          var r;
          return (r = e.initialize) == null ? void 0 : r.call(e, this);
        })
      );
    });
    A(this, "getApiIdentities", async () => (await Promise.all(
      this.plugins.filter(ss).map((r) => r.getIdentities(this))
    )).flat());
    A(this, "emitEvent", (e, ...r) => this.emitter.emit(e, ...r));
    A(this, "getPluginSidebar", async (e) => (await Promise.all(
      this.navigationPlugins.map(
        (n) => {
          var a;
          return (a = n.getSidebar) == null ? void 0 : a.call(n, jr(e), this);
        }
      )
    )).flatMap((n) => n ?? []));
    A(this, "signRequest", async (e) => {
      if (!this.authentication)
        throw new Error("No authentication provider configured");
      return await this.authentication.signRequest(e);
    });
    this.options = e, this.queryClient = r, this.plugins = e.plugins ?? [], this.topNavigation = e.topNavigation ?? [], this.sidebars = e.sidebars ?? {}, this.navigationPlugins = this.plugins.filter(es), this.authentication = e.authentication, this.meta = e.metadata, this.page = e.page, this.plugins.forEach((n) => {
      ts(n) && os(n.events).forEach(([a, i]) => {
        this.emitter.on(a, i);
      });
    }), br.subscribe((n, a) => {
      this.emitEvent("auth", {
        prev: a,
        next: n
      });
    });
  }
  addEventListener(e, r) {
    return this.emitter.on(e, r);
  }
}
function vn({ error: t, resetErrorBoundary: e }) {
  return /* @__PURE__ */ s.jsx(pt, { error: t });
}
const de = globalThis;
(!de.requestIdleCallback || !de.cancelIdleCallback) && (de.requestIdleCallback = (t) => setTimeout(t, 1), de.cancelIdleCallback = clearTimeout);
const It = {
  Header: _t
}, yn = Me(It), bn = yn.Provider, jn = () => {
  const t = pe(), e = F(), r = G(void 0);
  return Q(() => {
    e.emitEvent("location", {
      from: r.current,
      to: t
    }), r.current = t;
  }, [e, t]), null;
}, wn = ({
  children: t,
  context: e
}) => (wr({
  queryFn: async () => (await e.initialize(), !0),
  queryKey: ["zudoku-initialize"]
}), /* @__PURE__ */ s.jsx(Pr.Provider, { value: e, children: t }));
let rt;
const Ft = vt(
  ({ children: t, ...e }) => {
    var g, y;
    const r = be(
      () => ({ ...It, ...e.overrides }),
      [e.overrides]
    ), n = pe(), a = be(() => {
      var p;
      return {
        ...(e.plugins ?? []).filter(ns).flatMap(
          (C) => C.getMdxComponents ? [C.getMdxComponents()] : []
        ).reduce(
          (C, E) => ({ ...C, ...E }),
          {}
        ),
        ...Zr,
        ...(p = e.mdx) == null ? void 0 : p.components
      };
    }, [(g = e.mdx) == null ? void 0 : g.components, e.plugins]), { stagger: i } = Ar(Ne), [o, f] = J(!1), h = be(
      () => o ? { stagger: !0 } : { stagger: i },
      [i, o]
    ), l = ge(), b = ft();
    Q(() => {
      o || f(!0);
    }, [o, l.location]), rt ?? (rt = new xn(e, b));
    const v = (y = e.plugins) == null ? void 0 : y.flatMap(
      (m) => {
        var p;
        return as(m) ? ((p = m.getHead) == null ? void 0 : p.call(m, { location: n })) ?? [] : [];
      }
    ).map((m, p) => /* @__PURE__ */ s.jsx(Ee, { children: m }, p));
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      v,
      /* @__PURE__ */ s.jsx(Ne.Provider, { value: h, children: /* @__PURE__ */ s.jsxs(wn, { context: rt, children: [
        /* @__PURE__ */ s.jsx(jn, {}),
        /* @__PURE__ */ s.jsx(ys, { components: a, children: /* @__PURE__ */ s.jsx(ir, { attribute: "class", disableTransitionOnChange: !0, children: /* @__PURE__ */ s.jsx(bn, { value: r, children: /* @__PURE__ */ s.jsx(Nr, { slotlets: e.slotlets, children: /* @__PURE__ */ s.jsx(Vr, { children: t ?? /* @__PURE__ */ s.jsx(lt, {}) }) }) }) }) })
      ] }) })
    ] });
  }
);
Ft.displayName = "ZudokoInner";
const Qt = (t) => /* @__PURE__ */ s.jsx(mn, { FallbackComponent: vn, children: /* @__PURE__ */ s.jsx(Ft, { ...t }) });
Qt.displayName = "Zudoku";
const Zn = St, Vn = ln, Wn = Er, Gn = Ns, Xn = Ms, Jn = Os, ea = or, ta = Ee, Pn = F, ra = ae, sa = Sr, na = Cr, aa = Qt, oa = fn, ia = Tr, ca = Wr, la = yt, ua = xe, da = gt, fa = Te, ha = ct, ma = As;
export {
  da as B,
  na as C,
  ta as H,
  fa as L,
  ca as M,
  Wn as R,
  Gn as S,
  aa as Z,
  ra as a,
  Pn as b,
  Zn as c,
  Vn as d,
  Xn as e,
  Jn as f,
  ea as g,
  sa as h,
  oa as i,
  ia as j,
  la as k,
  ua as l,
  ha as m,
  ma as n,
  St as u
};
//# sourceMappingURL=index-BPmAnNGI.js.map
